import snakeCase from 'lodash/snakeCase';

import i18n from '@plugins/i18n';

const reportOrganisations = ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'];

const reportMeta = tabKey => ({
    overline: i18n.t('reports'),
    title: i18n.t('reports') + ' - ' + i18n.t('enums.reports_tabs.' + snakeCase(tabKey)),
    heading: i18n.t('enums.reports_tabs.' + snakeCase(tabKey)),
    organisations: reportOrganisations,
    sidebarKey: 'reports-sidebar',
    retainQuerySelectors: ['investor_id', 'adviser_id', 'tax_year']
});

export default [
    {
        path: '/reports',
        name: 'Reports',
        components: {
            default: () => import('@/views/Reports.vue'),
            sidebar: () => import('@/components/sidebars/ReportsSidebar.vue')
        },
        meta: {
            overline: i18n.t('reports'),
            title: i18n.t('_page.reports.heading'),
            heading: i18n.t('_page.reports.heading'),
            organisations: reportOrganisations,
            sidebarKey: 'reports-sidebar'
        },
        children: [
            {
                path: '/reports/adviser-documents-activity',
                name: 'ReportsAdviserDocumentsActivity',
                component: () => import('@/views/ReportsAdviserDocumentsActivity.vue'),
                meta: reportMeta('adviser_documents_activity')
            },
            {
                path: '/reports/adviser-marketing-activity',
                name: 'ReportsAdviserMarketingActivity',
                component: () => import('@/views/ReportsAdviserMarketingActivity.vue'),
                meta: reportMeta('adviser_marketing_activity')
            },
            {
                path: '/reports/adviser-security-activity',
                name: 'ReportsAdviserSecurityActivity',
                component: () => import('@/views/ReportsAdviserSecurityActivity.vue'),
                meta: reportMeta('adviser_security_activity')
            },
            {
                path: '/reports/auth-activity',
                name: 'ReportsAuthActivity',
                component: () => import('@/views/ReportsAuthActivity.vue'),
                meta: reportMeta('auth_activity')
            },
            {
                path: '/reports/client-portfolio',
                name: 'ReportsClientPortfolio',
                component: () => import('@/views/ReportsClientPortfolio.vue'),
                meta: reportMeta('client_portfolio')
            },
            {
                path: '/reports/client-summary',
                name: 'ReportsClientSummary',
                component: () => import('@/views/ReportsClientSummary.vue'),
                meta: reportMeta('client_summary')
            },
            {
                path: '/reports/clients-custodial-accounts',
                name: 'ReportsClientsCustodialAccounts',
                component: () => import('@/views/ReportsClientsCustodialAccounts.vue'),
                meta: reportMeta('clients_custodial_accounts')
            },
            {
                path: '/reports/disposals-failures',
                name: 'ReportsDisposalsFailures',
                component: () => import('@/views/ReportsDisposalsFailures.vue'),
                meta: reportMeta('disposals_failures')
            },
            {
                path: '/reports/disposals-sales',
                name: 'ReportsDisposalsSales',
                component: () => import('@/views/ReportsDisposalsSales.vue'),
                meta: reportMeta('disposals_sales')
            },
            {
                path: '/reports/dividend-transactions',
                name: 'ReportsDividendTransactions',
                component: () => import('@/views/ReportsDividendTransactions.vue'),
                meta: reportMeta('dividend_transactions')
            },
            {
                path: '/reports/holdings',
                name: 'ReportsHoldings',
                component: () => import('@/views/ReportsHoldings.vue'),
                meta: reportMeta('holdings')
            },
            {
                path: '/reports/integration-holdings',
                name: 'ReportsIntegrationHoldings',
                component: () => import('@/views/ReportsIntegrationHoldings.vue'),
                meta: reportMeta('integration_holdings')
            },
            {
                path: '/reports/integration-tranches',
                name: 'ReportsIntegrationTranches',
                component: () => import('@/views/ReportsIntegrationTranches.vue'),
                meta: reportMeta('integration_tranches')
            },
            {
                path: '/reports/investments-eis-seis',
                name: 'ReportsInvestmentsEisSeis',
                component: () => import('@/views/ReportsInvestmentsEisSeis.vue'),
                meta: reportMeta('investments_eis_seis')
            },
            {
                path: '/reports/investments-iht',
                name: 'ReportsInvestmentsIht',
                component: () => import('@/views/ReportsInvestmentsIht.vue'),
                meta: reportMeta('investments_iht')
            },
            {
                path: '/reports/investments-pmi',
                name: 'ReportsInvestmentsPmi',
                component: () => import('@/views/ReportsInvestmentsPmi.vue'),
                meta: reportMeta('investments_pmi')
            },
            {
                path: '/reports/investments-single-company',
                name: 'ReportsInvestmentsSingleCompany',
                component: () => import('@/views/ReportsInvestmentsSingleCompany.vue'),
                meta: reportMeta('investments_single_company')
            },
            {
                path: '/reports/investments-vct',
                name: 'ReportsInvestmentsVct',
                component: () => import('@/views/ReportsInvestmentsVct.vue'),
                meta: reportMeta('investments_vct')
            },
            {
                path: '/reports/investor-documents-activity',
                name: 'ReportsInvestorDocumentsActivity',
                component: () => import('@/views/ReportsInvestorDocumentsActivity.vue'),
                meta: reportMeta('investor_documents_activity')
            },
            {
                path: '/reports/investor-flow-activity',
                name: 'ReportsInvestorFlowActivity',
                component: () => import('@/views/ReportsInvestorFlowActivity.vue'),
                meta: reportMeta('investor_flow_activity')
            },
            {
                path: '/reports/investor-marketing-activity',
                name: 'ReportsInvestorMarketingActivity',
                component: () => import('@/views/ReportsInvestorMarketingActivity.vue'),
                meta: reportMeta('investor_marketing_activity')
            },
            {
                path: '/reports/investor-security-activity',
                name: 'ReportsInvestorSecurityActivity',
                component: () => import('@/views/ReportsInvestorSecurityActivity.vue'),
                meta: reportMeta('investor_security_activity')
            },
            {
                path: '/reports/investor-users',
                name: 'ReportsInvestorUsers',
                component: () => import('@/views/ReportsInvestorUsers.vue'),
                meta: {
                    ...reportMeta('investor_users'),
                    organisations: ['ADVISER']
                }
            },
            {
                path: '/reports/negligible-value',
                name: 'ReportsNegligibleValue',
                component: () => import('@/views/ReportsNegligibleValue.vue'),
                meta: reportMeta('negligible_value')
            },
            {
                path: '/reports/pending-applications',
                name: 'ReportsPendingApplications',
                component: () => import('@/views/ReportsPendingApplications.vue'),
                meta: reportMeta('pending_applications')
            },
            {
                path: '/reports/pmi-tranches',
                name: 'ReportsPmiTranches',
                component: () => import('@/views/ReportsPmiTranches.vue'),
                meta: reportMeta('pmi_tranches')
            },
            {
                path: '/reports/position-reconciliation',
                name: 'ReportsPositionReconciliation',
                component: () => import('@/views/ReportsPositionReconciliation.vue'),
                meta: reportMeta('position_reconciliation')
            },
            {
                path: '/reports/proposals',
                name: 'ReportsProposals',
                component: () => import('@/views/ReportsProposals.vue'),
                meta: reportMeta('proposals')
            },
            {
                path: '/reports/registrations',
                name: 'ReportsRegistrations',
                component: () => import('@/views/ReportsRegistrations.vue'),
                meta: reportMeta('registrations')
            },
            {
                path: '/reports/tax-year',
                name: 'ReportsTaxYear',
                component: () => import('@/views/ReportsTaxYear.vue'),
                meta: reportMeta('tax_year')
            },
            {
                path: '/reports/tax-return',
                name: 'ReportsTaxReturn',
                component: () => import('@/views/ReportsTaxReturn.vue'),
                meta: reportMeta('tax_return')
            },
            {
                path: '/reports/tranches',
                name: 'ReportsTranches',
                component: () => import('@/views/ReportsTranches.vue'),
                meta: reportMeta('tranches')
            },
            {
                path: '/reports/transaction-reconciliation',
                name: 'ReportsTransactionReconciliation',
                component: () => import('@/views/ReportsTransactionReconciliation.vue'),
                meta: reportMeta('transaction_reconciliation')
            },
            {
                path: '/reports/transactions-cash-deposits',
                name: 'ReportsTransactionsCashDeposits',
                component: () => import('@/views/ReportsTransactionsCashDeposits.vue'),
                meta: reportMeta('transactions_cash_deposits')
            },
            {
                path: '/reports/transactions-cash-withdrawals',
                name: 'ReportsTransactionsCashWithdrawals',
                component: () => import('@/views/ReportsTransactionsCashWithdrawals.vue'),
                meta: reportMeta('transactions_cash_withdrawals')
            },
            {
                path: '/reports/transactions-fee',
                name: 'ReportsTransactionsFee',
                component: () => import('@/views/ReportsTransactionsFee.vue'),
                meta: reportMeta('transactions_fee')
            },
            {
                path: '/reports/transactions-income',
                name: 'ReportsTransactionsIncome',
                component: () => import('@/views/ReportsTransactionsIncome.vue'),
                meta: reportMeta('transactions_income')
            },
            {
                path: '/reports/vct-maturity',
                name: 'ReportsVctMaturity',
                component: () => import('@/views/ReportsVctMaturity.vue'),
                meta: reportMeta('vct_maturity')
            },
            {
                path: '/reports/cash-fees',
                name: 'ReportsCashFees',
                component: () => import('@/views/ReportsCashFees.vue'),
                meta: reportMeta('cash_fees')
            },
            {
                path: '/reports/notifications',
                name: 'ReportsNotifications',
                component: () => import('@/views/ReportsNotifications.vue'),
                meta: reportMeta('notifications')
            }
        ]
    }
];
